import React from "react";

export default function Welcome() {
  return (
    <div className="welcome-wrapper">
      <h1>Jeroen Meij</h1>
      <p className="job-title">Software Developer</p>
    </div>
  )
}